<template>
  <el-dialog
    :visible="visible"
    append-to-body
    :show-close="false"
    :title="dialogTitle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="dialog-content">
      <i class="el-icon-loading loading-icon"></i>
      <div class="status-text">{{ title }}</div>
      <div class="dialog-loading-description" v-html="description"></div>
    </div>
  </el-dialog>
</template>

<script>
import { Vue, Component, Model, Emit, Prop } from 'vue-property-decorator';

@Component
export default class DailogLoading extends Vue {
  @Model('change', { type: Boolean, default: false }) visible;
  @Prop({ type: String, default: '导出处理中' }) dialogTitle;
  @Prop({ type: String, default: '数据处理中' }) title;
  @Prop({ type: String, default: '批量导出 <span class="highlight">n</span> 条数据，正在生成导出文件，预计需要 1-3 分钟，请等待' }) description;

  @Emit('change')
  handleClose() {
    return false;
  }
}
</script>

<style lang="scss">
.dialog-loading-description {
  margin-top: 15px;
  color: #666;
  font-size: 14px;

  .highlight {
    color: $primary;
  }
}
</style>

<style lang="scss" scoped>
.dialog-content {
  text-align: center;
  padding: 20px 0;

  .loading-icon {
    font-size: 40px;
    color: $primary;
  }

  .status-text {
    font-size: 16px;
    margin-top: 15px;
  }
}
</style>
